import React from 'react';
import { Link } from 'react-router-dom';
import { RETURN_ON_INVESTMENT_STATS } from '../dashboardStatsConfig';

function DashboardReturnOnInvestment({ getStat, isLoading, loadError, lastUpdated }) {
    return (
        <section className="ecx-page-card ecx-page-panel dashboard-stats-panel">
            <div className="ecx-page-panel__header">
                <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <div className="dashboard-stats-panel__heading">
                        <span className="ecx-page-icon-badge">
                            <i className="bi bi-graph-up-arrow" />
                        </span>
                        <div>
                            <h2 className="dashboard-stats-panel__title">Return on Investment</h2>
                            <p className="dashboard-stats-panel__subtitle mb-0">
                                {lastUpdated
                                    ? `Last 30 days · Updated ${lastUpdated}`
                                    : 'Confirmed appointments, feedback, and comments — last 30 days'}
                            </p>
                        </div>
                    </div>
                    <Link to="/reputation" className="btn btn-sm btn-light-primary rounded-pill">
                        Open reputation
                        <i className="bi bi-arrow-right ms-1" />
                    </Link>
                </div>
            </div>

            <div className="ecx-page-panel__body">
                {loadError && (
                    <div className="dashboard-alert" role="alert">
                        <i className="bi bi-exclamation-circle me-2" />
                        {loadError}
                    </div>
                )}

                {isLoading ? (
                    <div className="dashboard-section-grid">
                        {Array.from({ length: 3 }).map((_, index) => (
                            <div key={`roi-stat-skel-${index}`} className="dashboard-stat-tile dashboard-stat-tile--skeleton" />
                        ))}
                    </div>
                ) : (
                    <div className="dashboard-section-grid">
                        {RETURN_ON_INVESTMENT_STATS.map((stat) => (
                            <div key={stat.key} className="dashboard-stat-tile">
                                <span className="dashboard-stat-tile__label">
                                    <i className={`bi ${stat.icon} me-1`} aria-hidden="true" />
                                    {stat.label}
                                </span>
                                <span className="dashboard-stat-tile__value">{getStat(stat.key)}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default DashboardReturnOnInvestment;
